import { Box } from '@mui/material';
import styled from 'styled-components';

interface StackedSliderProps {
  $width: string;
}

interface LeftBorderProps {
  $margin?: string;
}

export const StackedVolumeContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const StackedVolumeWithRidersContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid #E6E6E6',
  borderRadius: '4px',
  padding: '24px',
  margin: '12px 0px',
});

export const StackedLineInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '50%',
});

export const StackedDropdownContainer = styled(Box)({
  width: '75%',
  marginRight: '2%',
  marginTop: '-12px',
});

export const StackedCoverageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column-reverse',
});

export const StackedCoverageInfoContainer = styled(Box)({
  display: 'flex',
  width: '50%',
});

export const StackedCovNewLineContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  border: '1px solid #3C548E',
  borderRadius: '4px',
  alignItems: 'center',
  padding: '24px',
  margin: '12px 0px',
  justifyContent: 'space-between',
  maxHeight: '64px',
});

export const StackedVolumeSliderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '12px',
});

export const StackedElectedSlider = styled(Box)<StackedSliderProps>(
  ({ $width }) => ({
    maxHeight: '12px',
    minHeight: '12px',
    minWidth: $width,
    width: $width,
    backgroundColor: '#00B9E0',
  })
);

export const StackedMaxSlider = styled(Box)({
  maxHeight: '12px',
  minHeight: '12px',
  minWidth: '100%',
  backgroundColor: '#BBC1D0',
});

export const LeftBorderCoverage = styled(Box)<LeftBorderProps>(
  ({ $margin }) => ({
    marginLeft: `calc(${$margin} - 1px)`,
    borderLeft: '1px solid #BBC1D0',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '8px',
  })
);

export const RightBorderCoverage = styled(Box)<LeftBorderProps>(
  ({ $margin }) => ({
    marginRight: `${$margin}`,
    marginLeft: 'auto',
    borderRight: '1px solid #BBC1D0',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '8px',
  })
);

export const MaxSliderValueContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const StackedTotalCostContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '24px',
  padding: '0px 40px',
  alignItems: 'flex-end',
});

export const StackedVolumeReviewContainer = styled(Box)({
  border: '1px solid #E6E6E6',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
});

export const StackedVolumeReadonlyContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'left',
  height: '100%'
});
